import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { defaultSettings, isStandalone } from '../../../constants';
import { useChannels } from '../../channels';
import { useChat } from '../../chat';
import { getInvertedColor } from '../../helpers';
import { AllInOneButton, StandaloneButton } from '../button';
import { MessageField } from '../field';

const BUTTON_MESSAGE =
  'No messengers are connected. Connect a messenger to enable the chat button.';
const INPUT_MESSAGE =
  'No messengers are connected. Connect a messenger to enable the ability to write a message.';

const ChatButtonComponent = () => {
  if (isStandalone) {
    return <StandaloneButton />;
  }

  return <AllInOneButton />;
};

export const ActionBlock = () => {
  const { chatMethod, chatWallpaper = defaultSettings.chatWallpaper } =
    useSettings();
  const channels = useChannels();
  const {
    targetChatButton: { appTitle, appLink }
  } = useChat();
  const isSendMessage = chatMethod === 'sendMessage';
  const withTextField = isStandalone && isSendMessage;
  const notConnected = !channels?.length;
  const messageColor = getInvertedColor({ color: chatWallpaper, opacity: 0.5 });

  if (notConnected) {
    return (
      <NoButtons>{isSendMessage ? INPUT_MESSAGE : BUTTON_MESSAGE}</NoButtons>
    );
  }

  return (
    <>
      {withTextField ? <MessageField /> : <ChatButtonComponent />}

      {!!appTitle && (
        <Message _color={messageColor}>
          To start a chat the {appTitle} app is required. You can download it
          here:
          <a href={appLink} rel="noreferrer" target="_blank">
            Download {appTitle}
          </a>
        </Message>
      )}
    </>
  );
};

const Message = styled.div<{ _color?: string }>`
  font-size: 13px;
  line-height: 16px;
  color: ${({ _color }) => _color};
  padding: 10px 20px 20px;

  & a {
    color: inherit;
    margin: 0 3px;
    border-bottom: ${({ _color }) => `1px solid ${_color}`};
    text-decoration: none;
  }
`;

const NoButtons = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 15px;
  line-height: 1.39;
  color: #f00;
  padding: 20px;
`;
